<template>
    <div id="app">
        <div class="pc-box">
            <Header/>
            <Banner/>
            <div class="content">
                <div class="content-left">
                    <router-view/>
                </div>
                <div class="content-right">
                    <ContentR/>
                </div>
            </div>
            <Suspension/>
            <Footer/>
            <Mobile/>
            <Advertising/>
        </div>
    </div>
</template>

<script>
import { Header } from 'shared'
import { Banner } from 'shared'
import ContentR from './views/ContentR'
import Footer from './views/Footer'
import { Suspension } from 'shared'
import { Mobile } from 'shared'
import Advertising from './views/Advertising'

export default {
    components: {
        Header,
        Banner,
        ContentR,
        Footer,
        Suspension,
        Mobile,
        Advertising
    },
    created() {
        this.$store.commit('getTaiwan', 'edu')
        this.$store.dispatch('getBannerZt', '教育')
        this.$store.dispatch('getBannerArticle', '教育')
        this.$store.commit('getSubmit', '在线教育')
        this.$store.commit('dataColor', {
            bar0: '#ff5c04',
            bar1: '#fbaa08',
            line0: '#3D8BF0',
            line1: '#CCE2FF'
        })
        this.$store.commit('getType', 11)
    },
}
</script>

<style>
</style>